import { BOPayTypeSellDetail } from "./BOPayTypeSellDetail.model";


export class BOSubServiceDetail{
  id?:number;
  subServiceTypeId?: number;
  subServiceTypeIdTemp?: number;
  subServiceName?:string;
  subServiceDetailIdTemp?: number;

  subServiceGroupId?:number;
  subServiceGroupName?:string;
  sellDetailId?: number;
  sellDetailIdTemp?:number;

  serviceTypeId?:number;
  serviceName?:string;
  profesionalId?:number;
  profesionalName?:string;
  date?:Date;
  observations?:string;
  price?:number;
  itemSaved?:boolean;
  areaId?:number;
  //No mapped columns
  documentNumber?: string;
  patientTypeId ?:number;
  patientId?:number;
  userIdString?: string;
  patientName?:string;
  sbSvcPayTypeSellDetails?:BOPayTypeSellDetail[]=[];
  sellId?:number;
}
